export default [
    {
        name: 'id',
        formItem: {
            type: 'hidden'
        }
    },
    {
        title: '共建类型',
        name: 'type',
        dict: [
          { code: 1, codeName: '4S网点' },
          { code: 2, codeName: '直营店' },
          { code: 3, codeName: '单一售后' },
          { code: 4, codeName: '单一销售' },
          { code: 5, codeName: '卫星店/直营店' },
          { code: 6, codeName: '自修站' },
          { code: 7, codeName: '卫星店' },
          { code: 8, codeName: '精品店' },
          { code: 9, codeName: 'dealer' },
          { code: 10, codeName: '4S店' },
          { code: 11, codeName: '汽车零售' },
          { code: 12, codeName: '单一销售展厅' },
          { code: 13, codeName: 'NEV单一售后' },
          { code: 14, codeName: '轻量化4S网点' },
          { code: 15, codeName: 'NEV专区' },
          { code: 16, codeName: '商超店' },
          { code: 17, codeName: '自修店' },
          { code: 18, codeName: '二级网点' },
          { code: 19, codeName: '车工坊C1' },
          { code: 20, codeName: '车工坊C2' },
          { code: 21, codeName: '车工坊B' },
          { code: 22, codeName: '德科品牌授权经销商' },
          { code: 99, codeName: '暂定' },
          { code: 0, codeName: '无' }
        ],
        tableItem: {}
    },
    {
      title: '经销商简称',
      name: 'shortName',
      tableItem: { }
    },
    {
      title: '销售代码',
      name: 'preSalesNumber',
      tableItem: {}
    },
    {
      title: '售后代码',
      name: 'afterSalesNumber',
      tableItem: {}
    },
    {
      title: '品牌',
      name: 'brandName',
      tableItem: {}
    },
    {
      title: '区域',
      name: 'areaName',
      tableItem: {}
    },
    {
        title: '开店状态',
        name: 'state',
        dict: [
          { code: 0, codeName: '已关店' },
          { code: 1, codeName: '已开店' },
          { code: 2, codeName: '建设中' }
        ],
        tableItem: {}
    }
]
